<template>
    <div>
        <div v-for="(lista,key) in arrayDetalle.ListaDet" :key="key">
            {{refreshLic}}
            <div v-for="(item,key2) in lista.detalle" :key="key2">
                <h3 class="color_Azul family-01 mb-3" v-show="(item.Titulo !='')">{{item.Titulo}}</h3>
                <hr class="divider-02 hr-sm-left-0 bg-color" v-show="(item.Titulo !='')">
                <h6 class="mb-3 color_Azul" v-show="(item.Subtitulo !='')">
                    {{item.Subtitulo}}
                </h6>
                
                <div v-if="(item.TipoTema == 'TEXTO' || item.TipoTema == 'IMAGEN' || item.TipoTema == 'ENLACES' || item.TipoTema == 'TABLA')">
                    <div v-if="(item.TipoTema == 'TEXTO')">
                        <p class="text-justify list-icon" v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-html="detalle.Descripcion"></p>
                    </div>

                    <div v-if="(item.TipoTema == 'IMAGEN')">
                        <div class="row" v-if="item.detContenidoTema.length>1">
                            <div class="col-12 col-sm-12 col-md-10 col-lg-12 col-xl-12">
                                <div :id="'slider'+key2" class="carousel slide mb-3 slide-full" data-ride="carousel">
                                    <ol class="carousel-indicators">
                                        <li v-for="(detalle,key3) in item.detContenidoTema" :key="key3" :data-target="'#slider'+key2" :data-slide-to="key3" :class="{'active':key3 == 0, '':key3 > 0}"></li>
                                    </ol>
                                    <div class="carousel-inner">
                                        <div :class="{'carousel-item active':key3 == 0, 'carousel-item':key3 > 0}" v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-show="(detalle.Archivo !='')">
                                            <img :src="RutaFile+detalle.Archivo" class="d-block w-100" alt="...">
                                        </div>
                                    </div>
                                    <a class="carousel-control-prev" :href="'#slider'+key2" role="button" data-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Anterior</span>
                                    </a>
                                    <a class="carousel-control-next" :href="'#slider'+key2" role="button" data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span class="sr-only">Siguiente</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-else>
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" v-for="(detalle,key3) in item.detContenidoTema" :key="key3" v-show="(detalle.Archivo !='')">
                                <img :src="RutaFile+detalle.Archivo" class="w-100 img-thumbnail mb-4 effect2" alt="ENES">
                            </div>
                        </div>
                    </div>

                    <div v-if="(item.TipoTema == 'ENLACES')">
                        <span v-if="(item.detContenidoTema.length>0)">
                            <span v-if="(item.detContenidoTema[0].Tipo == 'NORMAL')" class="list-icon">
                                {{/* SOLO PARA LOS ITEM LIST DE ENLACES*/}}
                                <ul class="list-01">
                                    <li v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                        <a :href="detalle.Enlace" target="_blank">{{detalle.Nombre}}</a>
                                    </li>
                                </ul>
                            </span>

                            <span v-else-if="(item.detContenidoTema[0].Tipo == 'PDFLINK')" class="list-icon">
                                {{/* SOLO PARA LOS ITEM LIST DE ARCHIVOS PDF*/ }}
                                <ul class="list-01">
                                    <li v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                        <a :href="RutaFile+detalle.Archivo" target="_blank">{{detalle.Nombre}}</a>
                                    </li>
                                </ul>
                            </span>

                            <span v-else-if="(item.detContenidoTema[0].Tipo == 'PDFBOTON')">
                                {{/* SOLO PARA LOS ARCHIVOS PDF CARGADOS CON POSIBILIDAD DE DESCARGAR O VER EN LINEA*/}}
                                <div class="row justify-content-center mb-3" v-if="item.detContenidoTema.length>1">
                                    <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                        <a class="button mb-3 mr-2" :href="RutaFile+detalle.Archivo" target="_blank" :download="(detalle.Archivo!='')?RutaFile+detalle.Archivo:''">
                                            <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                            {{detalle.NombreBtnEnlace}}
                                            <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row text-center" v-else>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"  v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                        <div style="width: 100%; overflow-y: hidden;" class="mb-3">
                                            <iframe :src="RutaFile+detalle.Archivo" width="100%" height="397"></iframe>
                                        </div>
                                        <a :href="(detalle.Archivo!='')?RutaFile+detalle.Archivo:'#'" :download="(detalle.Archivo!='')?RutaFile+detalle.Archivo:''" class="button" tabindex="0">
                                            <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                            {{detalle.NombreBtnEnlace}}
                                            <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                        </a>
                                    </div>
                                </div>
                            </span>

                            <span v-else-if="(item.detContenidoTema[0].Tipo == 'ENLACEBTN')">
                                {{/* SOLO PARA LOS ENLACES CON BOTON PARA IR A OTRO SITIO*/}}
                                <div class="row justify-content-center mb-3" v-if="item.detContenidoTema.length>1">
                                    <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5" v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                        <a class="button mr-2" :href="detalle.Enlace" target="_blank">
                                            <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                            {{detalle.NombreBtnEnlace}}
                                            <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row justify-content-center mb-3" v-else>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center">
                                        <a v-for="(detalle,key3) in item.detContenidoTema" :key="key3" class="button mr-2" :href="detalle.Enlace" target="_blank">
                                            <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                            {{detalle.NombreBtnEnlace}}
                                            <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                        </a>
                                    </div>
                                </div>
                            </span>
                            
                            <span v-else-if="(item.detContenidoTema[0].Tipo == 'ENLACEIMG')">
                                {{/* SOLO PARA LOS ENLACES CON IMAGEN PARA TIPO BOTON*/}}
                                <div class="row mb-4">
                                    <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" class="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                                        <a :href="detalle.Enlace" target="_blank" rel="noopener">
                                            <img :src="(detalle.Archivo!='')?RutaFile+detalle.Archivo:''" class="d-block w-100 mb-3 effect2" alt="ENES">
                                        </a>
                                    </div>
                                </div>
                            </span>

                            <span v-else-if="(item.detContenidoTema[0].Tipo == 'INFOGRAFIA')">
                                {{/* SOLO PARA LOS ENLACES CON IMAGEN PARA TIPO BOTON*/}}
                                <div class="row">
                                    <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3" class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                        <a :href="(detalle.Archivo!='')?RutaFile+detalle.Archivo:'#'" target="_blank">
                                            <div class="infografia-thumb">
                                                <img :src="(detalle.Archivo!='')?RutaFile+detalle.Archivo:''" alt="infografia Item">
                                                <div class="overlay">
                                                    <div class="inner">
                                                        <h4>{{detalle.Nombre}}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </span>
                        </span>
                    </div>

                    <div v-if="(item.TipoTema == 'TABLA')" class="mb-3">
                        <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                            <p class="text-justify list-icon" v-html="detalle.Descripcion"></p>
                            
                            <div class="row justify-content-center">
                                <div :class="{
                                    'col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5':detalle.Nombre =='CH',
                                    'col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8':detalle.Nombre == 'MD', 
                                    'col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12':detalle.Nombre == 'LG'
                                }">
                                    <div class="card card-lenguas">
                                        <div class="card-body">
                                            <table class="table table-lg table-lenguas">
                                                <thead>
                                                    <tr v-if="detalle.TituloTabla!=''">
                                                        <th v-if="(detalle.Tipo=='2X2')" colspan="2" class="text-center">
                                                            {{detalle.TituloTabla}}
                                                        </th>
                                                        <th v-else-if="(detalle.Tipo=='3X3')" colspan="3" class="text-center">
                                                            {{detalle.TituloTabla}}
                                                        </th>
                                                        <th v-else-if="(detalle.Tipo=='3X5')" colspan="5" class="text-center">
                                                            {{detalle.TituloTabla}}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th :class="'text-'+detalle.IconoIni">{{detalle.Titulo1}}</th>
                                                        <th :class="'text-'+detalle.IconoIni">{{detalle.Titulo2}}</th>
                                                        <th :class="'text-'+detalle.IconoIni" v-show="(detalle.Tipo!='2X2')" :colspan="(detalle.Tipo=='3X3')?1:3">
                                                            {{detalle.Titulo3}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(buff, indext) in detalle.detalletabla" :key="indext">
                                                        <td :class="'text-'+detalle.IconoFin">{{(buff.Camp1 == 'NA')?'':buff.Camp1}}</td>
                                                        <td :class="'text-'+detalle.IconoFin">
                                                            <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp2}}</b></span>
                                                            <span v-else>{{buff.Camp2}}</span>
                                                        </td>
                                                        <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo!='2X2')">
                                                            <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp3}}</b></span>
                                                            <span v-else>{{buff.Camp3}}</span>
                                                        </td>
                                                        <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo=='3X5')">
                                                            <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp4}}</b></span>
                                                            <span v-else>{{buff.Camp4}}</span>
                                                        </td>
                                                        <td :class="'text-'+detalle.IconoFin" v-show="(detalle.Tipo=='3X5')">
                                                            <span v-if="buff.Camp1 == 'NA'"><b>{{buff.Camp5}}</b></span>
                                                            <span v-else>{{buff.Camp5}}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <br>
                                            <div class="row">
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                                    {{detalle.HoraIni}}
                                                </div>
                                                <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                                    {{detalle.HoraFin}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="form-row" v-if="(item.TipoTema == 'ACORDEON')">
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 xl-12">
                        <div :id="'accordion'+item.IdDetalleTema" class="accordion">
                            <div v-for="(detalle,key3) in item.detContenidoTema" :key="key3">
                                <div class="card-header header-testi collapsed" data-toggle="collapse"
                            :data-parent="'#accordion'+item.IdDetalleTema" :href="'#collapse'+detalle.IdDetalleC">
                                    <h6 class="color_Azul">
                                        {{detalle.Nombre}}
                                    </h6>
                                </div>

                                <div :id="'collapse'+detalle.IdDetalleC" class="collapse " :data-parent="'#accordion'+item.IdDetalleTema">
                                    <div class="card-body">
                                        <p class="mb-3 text-justify list-icon" v-html="detalle.Descripcion"></p>

                                        <div class="row" v-if="detalle.Tipo == 'PDF'">
                                            {{/* VISTA DE UN PDF Y SI TIENE LA OPCION LE PERMITE DESCARGARLO */}}
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" >
                                                <div style="width: 100%; overflow-y: hidden;" class="mb-3">
                                                    <iframe :src="RutaFile+detalle.Archivo" width="100%" height="397"></iframe>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="detalle.BtnEnlace == 'SI'">
                                                <a :href="(detalle.Archivo!='')?RutaFile+detalle.Archivo:'#'" :download="(detalle.Archivo!='')?RutaFile+detalle.Archivo:''" class="button" tabindex="0">
                                                    <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                                    {{detalle.NombreBtnEnlace}}
                                                    <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="row" v-if="detalle.Tipo == 'PDFENLACE'">
                                            {{/* VISTA DE UN PDF MAS UN BOTON CON UN ENLACE*/}}
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center" >
                                                <div style="width: 100%; overflow-y: hidden;" class="mb-3">
                                                    <iframe :src="RutaFile+detalle.Archivo" width="100%" height="397"></iframe>
                                                </div>
                                            </div>
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="detalle.BtnEnlace == 'SI'">
                                                <a :href="detalle.Enlace" class="button" tabindex="0">
                                                    <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                                    {{detalle.NombreBtnEnlace}}
                                                    <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                                </a>
                                            </div>
                                        </div>

                                        <div class="row" v-if="detalle.Tipo == 'ENLACE'">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center" v-if="detalle.BtnEnlace == 'SI'">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center">
                                                        <a class="button" :href="detalle.Enlace" target="_blank">
                                                            <i :class="iconoFiltrado(detalle.IconoIni)" v-show="detalle.IconoIni !=''"></i>
                                                            {{detalle.NombreBtnEnlace}}
                                                            <i :class="iconoFiltrado(detalle.IconoFin)" v-show="detalle.IconoFin !=''"></i>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="(item.TipoTema == 'DIRECTORIO')">
                    <div class="row justify-content-center" v-if="(item.contactosTema.length>1)">
                        <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6" v-for="(detalle,key5) in item.contactosTema" :key="key5">
                            <div class="row pointer" onclick="open_modal('mysemblaza','maria_elena_giraldo_palacio.html');">
                                <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <div class="avatar-padre">
                                        <div class="avatar-hijo">
                                            <figure class="box-imge">
                                                <img :src="(detalle.Imagen!='')?RutaFileD+detalle.Imagen:''" v-show="(detalle.Imagen!='')" :alt="detalle.Nombre">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                    <div class="avatar-padre">
                                        <div class="avatar-hijo">
                                            <h5>{{detalle.Nombre}}</h5>
                                            <span>{{detalle.NomPuesto}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="avatar-item">
                                <div class="down-content">
                                    <ul>
                                        <li><b>Correo:</b>
                                            <a class="" :href="'mailto:'+detalle.Correo">{{detalle.Correo}}</a>
                                        </li>
                                        <li v-if="detalle.Correo2 != '' && detalle.Correo2!=null">
                                            <b>Correo:</b> <a :href="'mailto:'+detalle.Correo2"> {{detalle.Correo2}}</a>
                                        </li>
                                        <li v-if="detalle.Telefono != '' && detalle.Telefono!=null">
                                            <b>Tel.:</b> <a :href="'tel:+'+detalle.Telefono">{{detalle.Telefono}}</a>
                                        </li>
                                        <li v-if="detalle.Horario != '' && detalle.Horario!=null">
                                            <b>Hor.:</b>{{detalle.Horario}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mb-5 justify-content-center" v-else>
                        <div class="col-12 col-sm-12 col-md-10 col-lg-7 col-xl-7" v-for="(detalle,key5) in item.contactosTema" :key="key5">
                            <div class="row justify-content-center">
                                <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                                    <div class="avatar-padre">
                                        <div class="avatar-hijo">
                                            <figure class="box-imge">
                                                <img :src="(detalle.Imagen!='')?RutaFileD+detalle.Imagen:''" v-show="(detalle.Imagen!='')" :alt="detalle.Nombre">
                                            </figure>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                                    <div class="avatar-padre">
                                        <div class="avatar-hijo">
                                            <h5>{{detalle.Nombre}}</h5>
                                            <span>{{detalle.NomPuesto}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="avatar-item">
                                <div class="down-content">
                                    <ul>
                                        <li><b>Correo:</b>
                                            <a class="" :href="'mailto:'+detalle.Correo">{{detalle.Correo}}</a>
                                        </li>
                                        <li v-if="detalle.Correo2 != '' && detalle.Correo2!=null">
                                            <b>Correo:</b> <a :href="'mailto:'+detalle.Correo2"> {{detalle.Correo2}}</a>
                                        </li>
                                        <li v-if="detalle.Telefono != '' && detalle.Telefono!=null">
                                            <b>Tel.:</b> <a :href="'tel:+'+detalle.Telefono">{{detalle.Telefono}}</a>
                                        </li>
                                        <li v-if="detalle.Horario != '' && detalle.Horario!=null">
                                            <b>Hor.:</b>{{detalle.Horario}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
            </div>
            <hr class="divider-01" v-if="(lista.Separador == 'SI')">
        </div><!--fin de la seccion-->
    </div>
</template>

<script>
export default {
    name:'bodyLicenciatura',
    props:["arrayDetalle",'arrayIconos','Rutas'],
    data() {
        return {
            RutaFile: '',
            RutaFileD: '',
        }
    },
    methods: {
        iconoFiltrado(buscar)
        {
            let aBuscar = buscar;
            let devuelve = '';
            let arr = this.arrayIconos.filter(function(vl){
                if(aBuscar!=''){
                    if(aBuscar == vl.Id){
                        return vl;
                    }
                    else{
                        return '';
                    }
                }
            });

            if(arr[0]){
                devuelve = arr[0].Icono;
            }
            
            return devuelve;
        },
    },
    created() {
    },
    mounted() {
        this.RutaFile = this.Rutas.RutaFile;
        this.RutaFileD = this.Rutas.RutaFileD;
    },
    computed:{
        refreshLic: function(){
            this.RutaFile = this.Rutas.RutaFile;
            this.RutaFileD = this.Rutas.RutaFileD;
        }
    }
}
</script>